// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"portraitPhones": "all and (max-width:812px) and (orientation:portrait)",
	"landscapePhonesDown": "all and (max-width:812px)",
	"landscapePhones": "all and (max-width:812px) and (orientation:landscape)",
	"landscapePhonesUp": "all and (orientation:landscape)",
	"tabletsDown": "all and (max-width:991px)",
	"tablets": "all and (min-width:768px) and (max-width:991px)",
	"tabletsUp": "all and (min-width:768px)",
	"laptopsDown": "all and (max-width:1279px)",
	"laptops": "all and (min-width:992px) and (max-width:1279px)",
	"laptopsUp": "all and (min-width:992px)",
	"desktops": "all and (min-width:1280px)"
};
export default ___CSS_LOADER_EXPORT___;
